/*eslint-disable */
import store from '../store/index';

export default class AssetIconService {
  /**
   * Methods to load correct svg asset
   *
   */
  public static getSvgMapIcon(iconName: string): string {
    const { contrast} = store.state;
    const iconContrastType = contrast ? 'dark' : 'light';
    // eslint-disable-next-line global-require
    const contrastIcon = require(`@/assets/img/map-icons/${iconName}--${iconContrastType}.svg`);

    return contrastIcon;
  }

  public static getSvgNavIcon(iconName: string, isActive: boolean): string {
    const { contrast} = store.state;
    const iconContrastType = contrast ? 'dark' : 'light';
    const iconStatusType = isActive ? '_active' : '';
    // eslint-disable-next-line global-require
    const contrastIcon = require(`@/assets/img/nav/${iconName}${iconStatusType}--${iconContrastType}.svg`);

    return contrastIcon;
  }

  public static getSvgModalIcon(iconName: string): string {
    const { contrast} = store.state;
    const iconContrastType = contrast ? 'dark' : 'light';
    // eslint-disable-next-line global-require
    const contrastIcon = require(`@/assets/img/modal/${iconName}--${iconContrastType}.svg`);

    return contrastIcon;
  }

  public static getNavStandardSvgUrl(iconName: string): string {
    const contrastIcon = require(`@/assets/img/nav/${iconName}.svg`);

    return contrastIcon;
  }

  // public static getSvgIconThemeName(iconName: string): string {
  //   const { contrast} = store.state;
  //   const iconContrastType = contrast ? 'dark' : 'light';
  //   // eslint-disable-next-line global-require
  //   const contrastIcon = `${iconName}--${iconContrastType}`;

  //   return contrastIcon;
  // }
}
